export const API_URL = "https://telegram-mini-app-sample.onrender.com"